


  <div class="modal-dialog-centered modal-overlay" #add_cos tabindex="-1" aria-hidden="true" *ngIf="isOpen">
    <!--begin::Modal dialog-->

    <!--begin::Modal content-->
    <div class="modal-content pt-5  pb-15">
      <!--begin::Modal header-->
      <div class="modal-header">
        <!--begin::Modal title-->
        <h2 class="fw-bold"></h2>
        <!--end::Modal title-->
        <div class="h4">Ajouter consultant</div>
        <!--begin::Close-->
        <div id="ModalClose_add_consultant" class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal"
          aria-label="Close" (click)="close_modal_add()">
          <i class="fa-solid fa-xmark"></i>
        </div>

        <!--end::Close-->
      </div>
      <!--end::Modal header-->

      <!--begin::Modal body-->
      <div class="modal-body mx-5 my-7">
        <!--begin::Form-->
        <form action="" [formGroup]="formconsultant">
    
            <div class="row">
              <div class="col-lg-6">
                <label for="email" class="required">Email personnel</label>
                <input type="text" (change)="getconsultantByEmail($event)" 
                  formControlName="email" id="email" class="form-control mb-5" placeholder="email personnel">
                  <small  style="color: red;"  *ngIf="formconsultant.get('email')?.hasError('required') && formconsultant.get('email')?.touched">
                    Ce champ est requis.
                  </small>
                  <small   style="color: red;" *ngIf="formconsultant.get('email')?.hasError('email') && formconsultant.get('email')?.touched">
                    La valeur de ce champ doit être une adresse email valide.
                  </small>
                <div *ngIf="isexistemail || errorMessage" class="error-message" style="color: red;">{{
                  errorMessage }}</div>
                <div *ngIf="isexistemail || errorMessageprofil" class="error-message" style="color: red;">{{
                  errorMessageprofil }}</div>
              </div>
              <div class="col-lg-6">
                <label for="email">Email professionnel</label>
                <input type="text" formControlName="emailProESN" id="email " class="form-control mb-5"
                  placeholder="email professionnel">
                  <small  style="color: red;"  *ngIf="formconsultant.get('emailProESN')?.hasError('required') && formconsultant.get('emailProESN')?.touched">
                    Ce champ est requis.
                  </small>
                  <small   style="color: red;" *ngIf="formconsultant.get('emailProESN')?.hasError('email') && formconsultant.get('emailProESN')?.touched">
                    La valeur de ce champ doit avoir une adresse email valide.
                  </small>
  
              </div>


              <div class="col-lg-6">
                <label for="name" class="required">Nom</label>
                <input type="text" formControlName="first_name" id="name" class="form-control mb-5" placeholder="Nom">

  
             <div *ngIf="formconsultant.get('first_name')?.hasError('pattern') && formconsultant.get('first_name')?.touched"
                                  class="text-danger">
                                  La valeur de ce champ doit avoir un nom valide.
                              </div>
  
              </div>
              <div class="col-lg-6">
                <label for="name" class="required">Prénom</label>
                <input type="text" formControlName="last_name" id="name" class="form-control mb-5" placeholder="Prénom">

                <div
                  *ngIf="formconsultant.get('last_name')?.hasError('pattern') && formconsultant.get('last_name')?.touched"
                  class="text-danger">
                  La valeur de ce champ doit avoir un prénom valide.
                </div>
  
              </div>

              
              <div class="col-lg-6">
                <label for="web">
                  LinkedIn</label>
  
                <input type="text" formControlName="linkedin_link" id="name" class="form-control mb-5"
                  placeholder="https://www.linkedin.com/in/" (input)="setValidatorRequirements()">
  
        
                 <div *ngIf="formconsultant.get('linkedin_link')?.hasError('required') && formconsultant.get('linkedin_link')?.touched" class="text-danger">
                                          Le champ "linkedin_link" est obligatoire.
                                      </div>
                                      <div *ngIf="formconsultant.get('linkedin_link')?.hasError('pattern') && formconsultant.get('linkedin_link')?.touched" class="text-danger">
                                          Entrer une URL valide exemple: https://www.linkedin.com/in/exemple
                                      </div> 
  
              </div>
  
  
              <div class="col-lg-6">
                <div class="flex_input">
                  <div class="w-100">
                    <div class="labels">
                      <span *ngIf="!selectedconsultant" class="me-2">
                        <label for="cv">Importer CV</label>
                      </span>
                      <span *ngIf="selectedconsultant" class="me-2">
                        <label for="cv">Votre CV</label>
                      </span>

                      <i class="fa fa-info-circle me-2" aria-hidden="true"  [style]="{color: '#265d91'}"></i>

                      <span><strong>{{ selectedconsultant }}</strong></span>
                      <a class="cv"></a>
                      <button *ngIf="showResetButtons && fileName !== '' && !iscv" class="more-label" (click)="resetCV()">
                        <img src="assets/media/icons/icon-delete.png" alt="" width="30px" class="cursor-pointer">
                      </button>
  
                    </div>
  
                  </div>
                  <input *ngIf="!iscv" id="fileInput" #inputFile type="file" name="cv" id="cv"
                    (change)="uploadFile($event);setValidatorRequirements()" class="form-control mb-3">
  
                  <input *ngIf="iscv" type="text" name="cv" id="cv" formControlName="cv" class="form-control mb-3"
                    placeholder="cv" [readonly]="true" />
  
                  <span style="color:red" *ngIf="fileError"><small>{{ fileError }}</small></span>
                  <span style="color:red" *ngIf="fileExtention"><small>{{ fileExtention }}</small></span>
                </div>
              </div>

              <div class="col-lg-6">
                <label for="name">Poste</label>
                <input type="text" formControlName="desired_workstation" id="desired_workstation"
                  class="form-control mb-5" placeholder="poste">
              </div>
              <div class="col-lg-6 tools mb-10">
                <label for="fin">Client</label>
                <ng-select [items]="listclient" formControlName="client_id" bindLabel="name" bindValue="id"
                  [placeholder]="'Client'"></ng-select>
              </div>
              <div class="col-lg-6">
                <label for="début">Date de début Mission</label>
                <input type="date" formControlName="mission_start_date" id="debut" class="form-control mb-5"
                  [disabled]="!formconsultant.get('client_id')?.value">
              </div>
              <div class="col-lg-6">
                <label for="fin">Date de fin Mission</label>
                <input type="date" formControlName="mission_end_date" id="fin" class="form-control mb-5"
                  [disabled]="!formconsultant.get('client_id')?.value">
                <div *ngIf="formconsultant.hasError('dateRangeInvalid')" style="color: red;">
                  La date de début mission ne peut pas être supérieure à la date de fin mission.
                </div>
              </div>
              <div class="col-lg-6 tools mb-10">
                <label for="fin">Salaire</label>
                <div class="combined-input">
                  <input type="number" min="0" oninput="validity.valid||(value='0');" formControlName="salary"
                    id="Salaire" class="form-control" placeholder="Salaire &euro;">
                  <div class="euro">
                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                        fill="#4B4B4B" />
                    </svg>

                  </div>
                </div>
                <!-- <app-feild-error [control]="formconsultant.get('salary')" [controlName]="'salary'"></app-feild-error> -->

              </div>
              <div class="col-lg-6 tools mb-10">
                <label for="fin">TJM achat</label>
                <div class="combined-input">
                  <input type="number" min="0" oninput="validity.valid||(value='0');" formControlName="tjm_achat"
                    id="tjm_achat" class="form-control " placeholder="TJM achat &euro;">
                  <div class="euro">
                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                        fill="#4B4B4B" />
                    </svg>

                  </div>
                </div>
             <!--    <app-feild-error [control]="formconsultant.get('tjm_achat')"
                  [controlName]="'tjm_achat'"></app-feild-error> -->


              </div>

              
              <div class="col-lg-6 tools mb-5">
                <label for="fin">TJM vente</label>
                <div class="combined-input">
                  <input type="number" min="0" oninput="validity.valid||(value='0');" formControlName="tjm_vente"
                    id="tjm_vente" class="form-control " placeholder="TJM vente &euro;">
                  <div class="euro">
                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                        fill="#4B4B4B" />
                    </svg>

                  </div>
                </div>
              <!--   <app-feild-error [control]="formconsultant.get('tjm_vente')"
                  [controlName]="'tjm_vente'"></app-feild-error> -->


              </div>
              <div class="col-lg-6 tools mb-5">
                <label for="fin">Date signature de contrat</label>
                <input type="date" formControlName="date_signature_contrat" id="debut" class="form-control mb-5">
             <!--    <app-feild-error [control]="formconsultant.get('date_signature_contrat')"
                  [controlName]="'date_signature_contrat'"></app-feild-error> -->

              </div>

              <div class="col-lg-6 tools">
                <label for="fin">Manager</label>
                <ng-select [items]="listmanager" formControlName="manager_id" bindLabel="full_name" bindValue="id"
                  [placeholder]="'Manager'">
                </ng-select>

              <!--   <app-feild-error [control]="formconsultant.get('manager_id')"
                  [controlName]="'manager_id'"></app-feild-error> -->


              </div>

            </div>
  
          </form>
        <!--end::Form-->
      </div>
      <div class="card-footer text-center">
        <div class="actions">
          <button class="annuler" (click)="close_modal_add()">Annuler</button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button *ngIf="!isButtonDisabled"
            [disabled]="fileError ||fileExtention|| !isDateRangeValid()
            || formconsultant.get('email')?.invalid || formconsultant.get('emailProESN')?.invalid
            || formconsultant.get('last_name')?.invalid || formconsultant.get('first_name')?.invalid || formconsultant.get('linkedin_link')?.invalid"
            class="confirmer" (click)="createconsultant()">Confirmer</button>
          <button *ngIf="isButtonDisabled" class="confirmer disabled-button">Confirmer</button>
        </div>
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal content-->
  </div>
  <!--end::Modal dialog-->
